import React from 'react';
import type { Bonus } from '../types/content';
import { accentText, accentWash } from '../utils/accent';
type BonusCardProps = {
  bonus: Bonus;
};
export function BonusCard({
  bonus
}: BonusCardProps) {
  return <li className="flex w-full items-center gap-4 rounded-2xl bg-paper p-3 shadow-card sm:w-[calc(50%-0.5rem)] sm:gap-5 sm:p-4 lg:w-[calc(33.333%-0.84rem)]" data-id="element-17" data-mp="2t46igo4nil6g">
      <img src={bonus.cover} alt={`Bonus ${bonus.number} cover: ${bonus.title}`} loading="lazy" className="aspect-[1055/1491] w-[34%] max-w-[140px] shrink-0 rounded-md object-cover shadow-cover" data-id="element-18" data-mp="20eg3kcv73f9a" />
      <div className="min-w-0" data-id="element-19" data-mp="29ew71mbxume5">
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-20" data-mp="29durb4jz9bq3">
          <span className="text-[12px] font-semibold text-ink-mute" data-id="element-21" data-mp="2e6w8xkbkjpdd">Bonus #{bonus.number}</span>
          <span className={`rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] ${accentWash[bonus.accent]} ${accentText[bonus.accent]}`} data-id="element-22" data-mp="1hmx1c88zw58b">
            {bonus.audience}
          </span>
        </div>
        <h4 className="mt-1.5 font-display text-[19px] leading-tight text-ink sm:text-[21px]" data-id="element-23" data-mp="1x47pd8mcjval">{bonus.title}</h4>
        <p className="mt-1.5 text-[14px] leading-snug text-ink-soft" data-id="element-24" data-mp="1ncbmzld89j0k">{bonus.description}</p>
      </div>
    </li>;
}